import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthStatus } from '../types/interfaces/auth-status';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { isPlatformServer } from '@angular/common';
import { LoginResponse } from '../types/interfaces/login-response';
import { Tenant } from '../types/interfaces/tenant';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient = inject(HttpClient);
  private cookieService = inject(SsrCookieService);
  private platformId = inject(PLATFORM_ID);


  login(user: string, password: string): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(
      `${environment.apiHost}/auth/login`,
      {
        user,
        password,
      },
      {
        withCredentials: true,
      }
    );
  }

  logout(): Observable<object> {
    return this.httpClient.post(`${environment.apiHost}/auth/logout`, null, {
      withCredentials: true,
    });
  }

  isAuthenticated(): Observable<AuthStatus> {
    if (isPlatformServer(this.platformId)) {
      const cookies = Object.entries(this.cookieService.getAll())
        .map(([key, value]): string => `${key}=${value}`)
        .join('; ');

      return this.httpClient.get<AuthStatus>(
        `${environment.apiHost}/auth/status`,
        {
          withCredentials: true,
          headers: {
            cookie: cookies,
          },
        }
      );
    } else {
      return this.httpClient.get<AuthStatus>(
        `${environment.apiHost}/auth/status`,
        {
          withCredentials: true,
        }
      );
    }
  }

  getSessionTenant(): Observable<Tenant> {
    return this.httpClient.get<Tenant>(`${environment.apiHost}/auth/tenant`, {
      withCredentials: true,
    });
  }
}
